import { GradientEl } from "./StyledComponents";

export const BackGroundGradientEl = () => {
    return (
        <GradientEl>
        </GradientEl>
    )   
}

export default BackGroundGradientEl;